import { useEffect, useState } from 'react';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsCarBooking';
import axios from 'axios';

const EMPTY = {
  idVehiculo: 0,
  idReserva: 0,
  tipo: '',
  fecha: '',
  importe: '',
  descripcion: '',
  activo: true,
};

const endpointVehiculo = ENDPOINTS.vehiculo;
const modeloVehiculo = Models.vehiculo;

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    idVehiculo: '',
    idReserva: '',
    tipo: '',
    fecha: '',
    importe: '',
    descripcion: '',
  });
  const [vehiculos, setVehiculos] = useState([]);

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'idVehiculo':
        if (!value || Number(value) <= 0) error = 'Selecciona un vehículo.';
        break;
      case 'idReserva':
        if (!value || Number(value) <= 0) error = 'El ID de reserva es obligatorio.';
        break;
      case 'tipo':
        if (!value) error = 'El tipo es obligatorio.';
        break;
      case 'fecha':
        if (!value) error = 'La fecha es obligatoria.';
        break;
      case 'importe':
        if (value === '' || value === null || value === undefined) error = 'El importe es obligatorio.';
        break;
      case 'descripcion':
        if (!value) error = 'La descripción es obligatoria.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = ['idVehiculo', 'idReserva', 'tipo', 'fecha', 'importe', 'descripcion'];
    let isValid = true;
    fields.forEach(f => {
      if (!validateField(f, form[f])) isValid = false;
    });
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    const loadVehiculos = async () => {
      try {
        const res = await axios.get(endpointVehiculo);
        setVehiculos((res.data || []).map((x) => modeloVehiculo(x)));
      } catch (e) {
        console.error('Error al cargar vehículos en SiniestroModal', e);
      }
    };
    loadVehiculos();
  }, []);

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idSiniestro: data.idSiniestro ?? 0,
        idVehiculo: data.idVehiculo ?? 0,
        idReserva: data.idReserva ?? 0,
        tipo: data.tipo ?? '',
        fecha: (data.fecha ?? '').slice(0, 10),
        importe: data.importe ?? '',
        descripcion: data.descripcion ?? '',
        activo: data.activo ?? true,
      };
      setForm(filled);
      validateField('idVehiculo', filled.idVehiculo);
      validateField('idReserva', filled.idReserva);
      validateField('tipo', filled.tipo);
      validateField('fecha', filled.fecha);
      validateField('importe', filled.importe);
      validateField('descripcion', filled.descripcion);
    } else {
      setForm(EMPTY);
      setErrors({ idVehiculo: '', idReserva: '', tipo: '', fecha: '', importe: '', descripcion: '' });
    }
  }, [mode, data]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled =
    !form.idVehiculo ||
    !form.idReserva ||
    !form.tipo?.trim() ||
    !form.fecha ||
    form.importe === '' ||
    !form.descripcion?.trim() ||
    hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo siniestro' : 'Editar siniestro'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Vehículo:</label>
        <br /><br />
        <select
          className={`infoField${errors.idVehiculo ? ' infoField--error' : ''}`}
          value={form.idVehiculo || ''}
          onChange={(e) => handleChange('idVehiculo', Number(e.target.value) || 0)}
        >
          <option value="">-- Selecciona un vehículo --</option>
          {vehiculos.map((v) => {
            const placa = v.placa || 'S/placa';
            const marca = v.marca || '';
            const modeloV = v.modelo || '';
            const anio = v.anio || '';
            const detalle = [marca, modeloV, anio].filter(Boolean).join(' ');
            const label = detalle ? `${placa} · ${detalle}` : placa;
            return (
              <option key={v.idVehiculo} value={v.idVehiculo}>
                {label}
              </option>
            );
          })}
        </select>
        {errors.idVehiculo && <small style={errorStyle}>{errors.idVehiculo}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Id Reserva:</label>
        <br /><br />
        <input
          className={`infoField${errors.idReserva ? ' infoField--error' : ''}`}
          type="number"
          min={1}
          value={form.idReserva}
          onChange={(e) => handleChange('idReserva', Number(e.target.value) || 0)}
        />
        {errors.idReserva && <small style={errorStyle}>{errors.idReserva}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo:</label>
        <br /><br />
        <input
          className={`infoField${errors.tipo ? ' infoField--error' : ''}`}
          value={form.tipo}
          onChange={(e) => handleChange('tipo', e.target.value)}
          maxLength={100}
        />
        {errors.tipo && <small style={errorStyle}>{errors.tipo}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Fecha:</label>
        <br /><br />
        <input
          className={`infoField${errors.fecha ? ' infoField--error' : ''}`}
          type="date"
          onKeyDown={(e) => e.preventDefault()}
          value={form.fecha}
          onChange={(e) => handleChange('fecha', e.target.value)}
          onBlur={(e) => validateField('fecha', e.target.value)}
        />
        {errors.fecha && <small style={errorStyle}>{errors.fecha}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Importe:</label>
        <br /><br />
        <input
          className={`infoField${errors.importe ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.importe}
          onChange={(e) => handleChange('importe', e.target.value)}
        />
        {errors.importe && <small style={errorStyle}>{errors.importe}</small>}
      </div>

      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
        <br /><br />
        <textarea
          className={`infoField${errors.descripcion ? ' infoField--error' : ''}`}
          value={form.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          rows={3}
          maxLength={500}
        />
        {errors.descripcion && <small style={errorStyle}>{errors.descripcion}</small>}
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
